import type { IReportQuick } from './ReportQuick.interface';

export default class ReportQuick implements IReportQuick {
  object: string;
  time: string;
  timeFrom: string;
  timeTo: string;
  statuses: Array<string>;
  conversion: string;
  anniversary: string;
  stages: Array<string>;
  labels: Array<string>;
  lender: string;
  value: string;
  isLeaderBoard: boolean;
  isPipeline: boolean;
  isConversion: boolean;
  isTicket: Boolean;
  isProduct: Boolean;
  isContacts: boolean;

  static build = (data: IReportQuick) => new ReportQuick(data);
  static blank = () => new ReportQuick();

  /**
   * Constructor
   * @param {IReportQuick} data
   */
  constructor(data?: IReportQuick) {
    this.object = data?.object || undefined;
    this.time = data?.time || undefined;
    this.timeFrom = data?.timeFrom || undefined;
    this.timeTo = data?.timeTo || undefined;
    this.statuses = data?.statuses || [];
    this.conversion = data?.conversion || undefined;
    this.anniversary = data?.anniversary || undefined;
    this.stages = data?.stages || [];
    this.labels = data?.labels || [];
    this.lender = data?.lender || undefined;
    this.value = data?.value || undefined;
    this.isLeaderBoard = data?.isLeaderBoard === true;
    this.isPipeline = data?.isPipeline === true;
    this.isConversion = data?.isConversion === true;
    this.isTicket = data?.isTicket === true;
    this.isProduct = data?.isProduct === true;
    this.isContacts = data?.isContacts === true;
  }
}
